import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material'
import React, { useContext } from 'react'
import themeOptions from './theme'
import { SettingsContext } from '../context/setting'

const cssTheme = [
  'customColors',
  'common',
  'primary',
  'secondary',
  'error',
  'warning',
  'info',
  'success',
  'grey',
  'text',
  'background',
  'action',
  'divider'
]

const ThemeComponent = (props) => {
  // ** Props
  const { children } = props
  const { settings } = useContext(SettingsContext)

  // ** Pass merged ThemeOptions (of core and user) to createTheme function
  let theme = createTheme(themeOptions(settings, 'light'))

  theme = responsiveFontSizes(theme)

  cssTheme.forEach((key) => {
    if (typeof theme.palette[key] === 'string') {
      document.documentElement.style.setProperty(`--${key}`, theme.palette[key])
    } else {
      Object.keys(theme.palette[key]).forEach((innerKey) => {
        document.documentElement.style.setProperty(
          `--${key}-${innerKey}`,
          theme.palette[key][innerKey]
        )
      })
    }
  })

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default ThemeComponent
